import 'bootstrap/dist/css/bootstrap.min.css';
import '@tabler/icons-webfont/dist/tabler-icons.min.css';
import './App.css';

import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Home from './Components/Home';
import PageHeader from './PageHeader';
import CartPage from './Components/Cart';
import CheckOutPage from './Components/Checkout';
import OrderResults from './Components/OrderResults';
import { EventProvider, useEvent, TimerProvider,EventContext } from './CartContext'; // Import EventProvider and useEvent
import FacebookPixelTracker from './facebookPixel';
import MyAccount from './Components/MyAccount';
import OrderDetails from './Components/OrderDetails';
import useSubdomain from './useSubdomain';
import TrackPageView from './TrackPageView';
import EmailChangeStatus from './Components/EmailStatusChange';
import ErrorBoundary from './ErrorBoundary';

function App() {
  const [isTimeActive, setIsTimeActive] = useState(false);
  const subdomain = useSubdomain();

  const toggleTimer = () => {
    setIsTimeActive(true);
  };

  return (
    <div className="App">
      <FacebookPixelTracker />
      <EventProvider eventUrl={subdomain}>
        <TimerProvider>
          <TrackPageView />
          <Container className="p-0">
            <PageHeader isTimeActive={isTimeActive}></PageHeader>
          <ErrorBoundary>
            <AppRoutes toggleTimer={toggleTimer} />
          </ErrorBoundary>
          </Container>
        </TimerProvider>
      </EventProvider>
    </div>
  );
}

// AppRoutes component is responsible for rendering routes
function AppRoutes({ toggleTimer }) {
  const { globalEventId, loading } = useEvent(); // Using the context to get loading and globalEventId

  if (loading) {
    return <div>Loading event data...</div>; // Show loading state until globalEventId is fetched
  }

  return (
    <Routes>
      <Route path="/" element={<Home toggleTimer={toggleTimer} />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/cart/:id" element={<CartPage />} />
      <Route path="/checkout" element={<CheckOutPage />} />
      <Route path="/order-results" element={<OrderResults />} />
      <Route path="/my-account" element={<MyAccount />} />
      <Route path="/my-account/order-details/:order_num" element={<OrderDetails />} />
      <Route path="/email-change-status" element={<EmailChangeStatus />} />

    </Routes>
  );
}

export default App;
